// test2777
(2777 && 0);
